module.exports = __webpack_public_path__ + "img/linkedin.7511ba54.svg";